// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/components/forms/Blocks/index.ts"
);
import.meta.hot.lastModified = "1785263142239.6362";
}
// REMIX HMR END

import Checklist_DecoupledArchitectures from "./Checklist_DecoupledArchitectures";
import ContactUs from "./ContactUs";
import EventDrupalcon2025 from "./EventDrupalcon2025";
import Events from "./Events";
import Subscribe from "./Subscribe";
import Webinar from "./Webinar";
import Webinar_A11yAuditTool from "./Webinar_A11yAuditTool";
import Webinar_Accessibility from "./Webinar_Accessibility";
import Webinar_FromZeroToDecoupled from "./Webinar_FromZeroToDecoupled";
import Webinar_SSG from "./Webinar_SSG";
import Webinar_AIClaims from "./Webinar_AIClaims"
import Webinar_OpenSourceGuide from "./Webinar_OpenSourceGuide"
import Webinar_DrupalDecoupledDemo from "./Webinar_DrupalDecoupledDemo";

export const formBlockMap = {
  contact_us: ContactUs,
  events: Events,
  subscribe_checklist: Subscribe,
  webinar: Webinar,
  event_drupalcon2025: EventDrupalcon2025,
  webinar_from_zero_to_decoupled: Webinar_FromZeroToDecoupled,
  webinar_accessibility: Webinar_Accessibility,
  webinar_ssg: Webinar_SSG,
  webinar_aiclaims: Webinar_AIClaims,
  webinar_opensourceguide: Webinar_OpenSourceGuide,
  webinar_drupaldecoupleddemo: Webinar_DrupalDecoupledDemo,
  webinar_a11yaudittool: Webinar_A11yAuditTool,
  checklist_decoupledarchitectures: Checklist_DecoupledArchitectures,
};
